import { render, staticRenderFns } from "./Nomination_Confirmation.vue?vue&type=template&id=ccbab744&scoped=true&"
import script from "./Nomination_Confirmation.vue?vue&type=script&lang=js&"
export * from "./Nomination_Confirmation.vue?vue&type=script&lang=js&"
import style0 from "./Nomination_Confirmation.vue?vue&type=style&index=0&id=ccbab744&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbab744",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VForm,VIcon,VTextField})
